import React from 'react';
import PageSeo from '../components/seo/PageSeo';
import {
  FaYoutube,
  FaGlobe,
  FaRobot,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaArrowUpRightFromSquare,
} from 'react-icons/fa6';

import logo from '../img/logo.png';
import '../styles/InfoPage.css';

const About = () => {
  return (
    <main className="about-page">
      <PageSeo routePath="/about" />

      <div className="about-container">
        {/* Hero */}
        <section className="about-hero">
          <div className="about-hero__content">
            <span className="about-eyebrow">
              Український спортивний медіапроєкт
            </span>

            <h1>
              Ми створюємо спорт,
              <span> який хочеться читати</span>
            </h1>

            <p className="about-hero__description">
              <strong>BigSport</strong> — незалежний український спортивний
              портал про головні події українського та світового спорту. Ми
              поєднуємо оперативні новини, сучасні цифрові технології та
              зрозумілу подачу інформації.
            </p>

            <div className="about-hero__actions">
              <a
                href="mailto:bigsport.com.ua@gmail.com"
                className="about-btn about-btn--primary"
              >
                <FaEnvelope />
                Зв’язатися з редакцією
              </a>

              <a
                href="https://www.linkedin.com/company/bigsport"
                target="_blank"
                rel="noopener noreferrer"
                className="about-btn about-btn--secondary"
              >
                LinkedIn BigSport
                <FaArrowUpRightFromSquare />
              </a>
            </div>
          </div>

          <div className="about-hero__visual">
            <div className="about-logo-card">
              <div className="about-logo-card__glow" />

              <img src={logo} alt="Емблема BigSport" />

              <div className="about-logo-card__line" />

              <p>Новини. Аналітика. Спорт.</p>
            </div>
          </div>
        </section>

        {/* Про проєкт */}
        <section className="about-section about-intro">
          <div className="about-section-heading">
            <span>Про проєкт</span>
            <h2>BigSport сьогодні</h2>
          </div>

          <div className="about-intro__grid">
            <div className="about-intro__text">
              <p>
                BigSport створено для вболівальників, які хочуть швидко
                отримувати найважливішу спортивну інформацію без зайвого
                інформаційного шуму.
              </p>

              <p>
                На сайті публікуються новини, результати матчів, трансфери,
                огляди турнірів, заяви спортсменів і тренерів, а також матеріали
                про український та міжнародний спорт.
              </p>

              <p>
                Ми прагнемо, щоб кожна публікація не лише повідомляла факт, а й
                допомагала читачеві зрозуміти контекст події.
              </p>
            </div>

            <div className="about-highlight">
              <span className="about-highlight__number">2023</span>
              <p>
                Рік, з якого розпочалася історія BigSport як спортивного
                YouTube-проєкту.
              </p>
            </div>
          </div>
        </section>

        {/* Історія */}
        <section className="about-section about-history">
          <div className="about-section-heading">
            <span>Наш шлях</span>
            <h2>Історія BigSport</h2>

            <p>
              Від аматорського YouTube-каналу до повноцінного спортивного
              цифрового медіа.
            </p>
          </div>

          <div className="about-timeline">
            <article className="about-timeline-item">
              <div className="about-timeline-item__marker">
                <FaYoutube />
              </div>

              <div className="about-timeline-item__content">
                <time>Березень 2023 року</time>
                <h3>Створення YouTube-каналу</h3>

                <p>
                  BigSport розпочав свій шлях як аматорський YouTube-канал зі
                  створення спортивних відео. Проєкт був заснований на любові
                  до спорту та бажанні розповідати про головні події у
                  доступному форматі.
                </p>
              </div>
            </article>

            <article className="about-timeline-item">
              <div className="about-timeline-item__marker">
                <FaYoutube />
              </div>

              <div className="about-timeline-item__content">
                <time>2024 рік</time>
                <h3>Монетизація каналу</h3>

                <p>
                  Приблизно через рік після запуску YouTube-канал отримав
                  монетизацію. Це стало першим важливим підтвердженням того, що
                  контент BigSport знаходить свою аудиторію.
                </p>
              </div>
            </article>

            <article className="about-timeline-item">
              <div className="about-timeline-item__marker">
                <FaGlobe />
              </div>

              <div className="about-timeline-item__content">
                <time>Липень 2024 року</time>
                <h3>Початок розробки сайту</h3>

                <p>
                  Засновник і розробник проєкту Віталій Скочко розпочав
                  створення спортивного новинного порталу. На першому етапі
                  сайт працював у тестовому режимі, а функціональність
                  поступово розширювалася.
                </p>
              </div>
            </article>

            <article className="about-timeline-item">
              <div className="about-timeline-item__marker">
                <FaRobot />
              </div>

              <div className="about-timeline-item__content">
                <time>2024–2025 роки</time>
                <h3>Розробка технологічної платформи</h3>

                <p>
                  Для BigSport була створена власна серверна частина та
                  система, яка за допомогою AI допомагає збирати й
                  структурувати дані про головні новини зі світу спорту.
                </p>

                <p>
                  Технологія автоматизує частину редакційних процесів, проте
                  фінальне опрацювання, перевірка та публікація матеріалів
                  залишаються під контролем редакції.
                </p>
              </div>
            </article>

            <article className="about-timeline-item about-timeline-item--active">
              <div className="about-timeline-item__marker">
                <img src={logo} alt="" aria-hidden="true" />
              </div>

              <div className="about-timeline-item__content">
                <time>30 березня 2025 року</time>
                <h3>Офіційний запуск BigSport</h3>

                <p>
                  Після періоду тестування сайт BigSport офіційно розпочав
                  роботу як український спортивний інформаційний портал.
                </p>
              </div>
            </article>

            <article className="about-timeline-item">
              <div className="about-timeline-item__marker">
                <FaGlobe />
              </div>

              <div className="about-timeline-item__content">
                <time>Сьогодні</time>
                <h3>Повноцінний спортивний медіапроєкт</h3>

                <p>
                  Сьогодні BigSport має власний сайт, аудиторію та офіційні
                  сторінки в Instagram, Facebook, YouTube і LinkedIn. Проєкт
                  продовжує розвивати технологічну платформу, контент і
                  взаємодію з українськими вболівальниками.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* Місія */}
        <section className="about-mission">
          <div className="about-mission__logo">
            <img src={logo} alt="BigSport" />
          </div>

          <div className="about-mission__content">
            <span>Наша місія</span>

            <h2>
              Робити українське спортивне медіа сучасним, швидким і доступним
            </h2>

            <p>
              Ми прагнемо популяризувати спорт, підтримувати інтерес до
              українських команд і спортсменів та створювати зручний простір,
              де читач може знайти головне про події в Україні й у світі.
            </p>
          </div>
        </section>

        {/* Напрями */}
        <section className="about-section">
          <div className="about-section-heading">
            <span>Тематика</span>
            <h2>Що висвітлює BigSport</h2>
          </div>

          <div className="about-topics">
            <article className="about-topic-card">
              <span>01</span>
              <h3>Український футбол</h3>
              <p>
                УПЛ, Перша та Друга ліги, Кубок України, національна збірна,
                трансфери та клубні новини.
              </p>
            </article>

            <article className="about-topic-card">
              <span>02</span>
              <h3>Світовий футбол</h3>
              <p>
                Провідні чемпіонати Європи, міжнародні турніри, єврокубки та
                головні трансферні події.
              </p>
            </article>

            <article className="about-topic-card">
              <span>03</span>
              <h3>Бокс і MMA</h3>
              <p>
                Чемпіонські бої, анонси, результати поєдинків, рейтинги та
                заяви спортсменів.
              </p>
            </article>

            <article className="about-topic-card">
              <span>04</span>
              <h3>Теніс і біатлон</h3>
              <p>
                Турніри ATP і WTA, Grand Slam, Кубок світу з біатлону та
                виступи українських спортсменів.
              </p>
            </article>

            <article className="about-topic-card">
              <span>05</span>
              <h3>Інші види спорту</h3>
              <p>
                Футзал, баскетбол, хокей, автоспорт та головні міжнародні
                спортивні події.
              </p>
            </article>

            <article className="about-topic-card">
              <span>06</span>
              <h3>Аналітика й огляди</h3>
              <p>
                Результати матчів, статистика, ключові факти та пояснення
                найважливіших спортивних подій.
              </p>
            </article>
          </div>
        </section>

        {/* Принципи */}
        <section className="about-section">
          <div className="about-section-heading">
            <span>Редакційні цінності</span>
            <h2>Наші принципи</h2>
          </div>

          <div className="about-values">
            <article>
              <strong>01</strong>
              <div>
                <h3>Оперативність</h3>
                <p>
                  Швидко повідомляємо про важливі події після перевірки
                  основної інформації.
                </p>
              </div>
            </article>

            <article>
              <strong>02</strong>
              <div>
                <h3>Достовірність</h3>
                <p>
                  Використовуємо офіційні повідомлення, заяви клубів,
                  федерацій, спортсменів і перевірені джерела.
                </p>
              </div>
            </article>

            <article>
              <strong>03</strong>
              <div>
                <h3>Зрозуміла подача</h3>
                <p>
                  Пишемо просто й по суті, пояснюючи значення подій для
                  команд, спортсменів і вболівальників.
                </p>
              </div>
            </article>

            <article>
              <strong>04</strong>
              <div>
                <h3>Відповідальне використання AI</h3>
                <p>
                  Застосовуємо технології для автоматизації збору та
                  структурування інформації, зберігаючи редакційний контроль
                  над публікаціями.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* Засновник */}
        <section className="about-founder">
          <div className="about-founder__content">
            <span className="about-founder__label">
              Засновник і головний редактор
            </span>

            <h2>Віталій Скочко</h2>

            <p>
              Засновник, розробник і головний редактор BigSport. Відповідає за
              розвиток платформи, її технічну архітектуру, цифрові продукти та
              редакційну стратегію проєкту.
            </p>

            <a
              href="https://www.linkedin.com/in/vitaliy-skochko-b8a150336/"
              target="_blank"
              rel="noopener noreferrer"
              className="about-founder__link"
            >
              <FaLinkedinIn />
              Профіль у LinkedIn
              <FaArrowUpRightFromSquare />
            </a>
          </div>

          <div className="about-founder__brand">
            <img src={logo} alt="Емблема BigSport" />
          </div>
        </section>

        {/* Соцмережі */}
        <section className="about-section">
          <div className="about-section-heading">
            <span>Спільнота</span>
            <h2>BigSport у соціальних мережах</h2>

            <p>
              Підписуйтеся, щоб отримувати новини, відео та головні спортивні
              події у зручному форматі.
            </p>
          </div>

          <div className="about-socials">
            <a
              href="https://www.youtube.com/@BigSport-TV1"
              target="_blank"
              rel="noopener noreferrer"
              className="about-social-card about-social-card--youtube"
            >
              <FaYoutube />
              <div>
                <strong>YouTube</strong>
                <span>Спортивні відео</span>
              </div>
              <FaArrowUpRightFromSquare />
            </a>

            <a
              href="https://www.instagram.com/bigsport.com.ua/"
              target="_blank"
              rel="noopener noreferrer"
              className="about-social-card about-social-card--instagram"
            >
              <FaInstagram />
              <div>
                <strong>Instagram</strong>
                <span>Новини та візуальний контент</span>
              </div>
              <FaArrowUpRightFromSquare />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61587925061004"
              target="_blank"
              rel="noopener noreferrer"
              className="about-social-card about-social-card--facebook"
            >
              <FaFacebookF />
              <div>
                <strong>Facebook</strong>
                <span>Головні спортивні події</span>
              </div>
              <FaArrowUpRightFromSquare />
            </a>

            <a
              href="https://www.linkedin.com/company/bigsport"
              target="_blank"
              rel="noopener noreferrer"
              className="about-social-card about-social-card--linkedin"
            >
              <FaLinkedinIn />
              <div>
                <strong>LinkedIn</strong>
                <span>Розвиток медіапроєкту</span>
              </div>
              <FaArrowUpRightFromSquare />
            </a>
          </div>
        </section>

        {/* Контакти */}
        <section className="about-contact">
          <div>
            <span>Зв’язок із редакцією</span>

            <h2>Маєте новину, пропозицію або ідею для співпраці?</h2>

            <p>
              Надсилайте пресрелізи, інформацію про спортивні події, пропозиції
              щодо партнерства та зауваження до матеріалів.
            </p>
          </div>

          <a href="mailto:bigsport.com.ua@gmail.com">
            <FaEnvelope />
            bigsport.com.ua@gmail.com
          </a>
        </section>
      </div>
    </main>
  );
};

export default About;
